import React, { useEffect, useState } from 'react';
import { MdRestore } from "react-icons/md";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../commonForm/Loader';
import ViewIcon from "../../assets/images/Icons/view.svg"
import EditIcon from "../../assets/images/Icons/edit.svg"
import DeleteIcon from "../../assets/images/Icons/delete.svg"
import { Link, useNavigate } from 'react-router-dom';
import useUserStore from '../../store/UserStore.js';
import Pagination from '../commonForm/Pagination.js';
import Swal from 'sweetalert2';
import axios from 'axios';
import { BASE_URL } from '../../constant/const.js';
import ViewCustomer from './AddCustomer/ViewCustomer.js';
import ToggleButton from '../commonForm/ToggleButton.js';
import { t } from '../Language/Translator.js';
import DatePicker from 'react-datepicker';


const CustomerList = () => {
  const [customerData, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [isLoadingCustomer, setIsLoadingCustomer] = useState(false); // New loading state
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [viewModalopen, setViewModalOpen] = useState(false);

  const [customerSearchData, setCustomerSearchData] = useState(null);
  const [customerId, setCustomerId] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [email, setEmail] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [status, setStatus] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [loadingItemId, setLoadingItemId] = useState(null);
  const [isAnyLoading, setIsAnyLoading] = useState(false);
  const [toggle, setToggle] = useState({ isActive: false });

  const navigate = useNavigate();

  const customer_data = useUserStore((state) => state.user);
  const token = customer_data;


  const paginate = async (pageNumber) => {
    setCurrentPage((pageNumber));
    if (customerSearchData) {
      await fetchSearchData();
      setCustomerSearchData(prev => ({ ...prev, page: currentPage }));
    }
  };

  useEffect(() => {
    if (customerSearchData) {
      setLoading(true);
      fetchSearchData();
    }
    else {
      getAllCustomers();
    }
  }, [currentPage, customerSearchData])

  if (loading) {
    return <Loader />
  };

  //------------------------------GET ALL CUSTOMERS----------------------------------

  async function getAllCustomers() {
    try {
      const config = {
        headers: {
          "Content-type": "application/json",
          "Authorization": token,
        },
      };
      const response = await axios.get(`${BASE_URL}customer/customers?page=${currentPage}&pageSize=${itemsPerPage}`, config);
      setData(response.data.data || []);
      setTotalItems(response.data.pagination.totalItems);
      setLoading(false);
    }
    catch (error) {
      setError(error.message);
      setLoading(false);
    }
  };

  //----------------------------DELETE CUSTOMER RECORD---------------------------------

  async function handleDeleteCustomer(customerId) {
    try {
      const config = {
        headers: {
          "Content-type": "application/json",
          "Authorization": token,
        },
      };
      const response = await axios.delete(`${BASE_URL}customer/delete-customer/${customerId}`, config);

      toast.success(response.data.message);
    }
    catch (error) {
      if (error.response) {
        toast.warning(error.response.data.message);
      }
      else {
        toast.error(error.message);
      }
    }
  };


  function deleteCustomeralert(customerId) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this customer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#19C489',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteCustomer(customerId).then(() => {
          Swal.fire({
            title: 'Deleted!',
            text: 'Your customer has been deleted.',
            icon: 'success',
            confirmButtonColor: '#19C489',
          });
        });
        setData(prevData => 
          prevData.map(item => 
              item.customerId === customerId 
                  ? { ...item, isDeleted: true } // Set isDeleted to true for the specified customer
                  : item // Keep the other customers unchanged
          )
        );
      }
    });
  }

  async function restoreCustomeralert(customerId) {
   
    try {
      const config = {
        headers: {
          "Content-type": "application/json",
          "Authorization": token,
        },
      };
      
      const response = await axios.get(`${BASE_URL}customer/restoreDeletedCustomer/${customerId}`, config);
      setData(prevData => 
        prevData.map(item => 
            item.customerId === customerId 
                ? { ...item, isDeleted: false } // Set isDeleted to true for the specified customer
                : item // Keep the other customers unchanged
        )
      );

      toast.success(response.data.message);
    }
    catch (error) {
      if (error.response) {
        toast.warning(error.response.data.message);
      }
      else {
        toast.error(error.message);
      }
    }
  }

  // ------------------------------------------SEARCH CUSTOMER DATA---------------------------------------

  async function fetchSearchData() {


    try {
      const searchPayload = {
        ...customerSearchData, page: currentPage
      }
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
        },
      };
      const response = await axios.post(`${BASE_URL}customer/search-customer?page=${currentPage}&pageSize=${itemsPerPage}`, searchPayload, config);
    
      setData(response.data.data || []);
      setTotalItems(response.data.pagination.totalItems || 0);
      setLoading(false);
    }
    catch (error) {
      setError(error.message);
      setLoading(false);

    }

  };

  // --------------------------------------------------SEARCH CUSTOMER--------------------------------

  const handleSearch = (event) => {
    event.preventDefault();
    let mysqlDateTimeFormat;
    if (selectedDate) {
      const date = new Date(selectedDate);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const day = String(date.getDate()).padStart(2, '0');
      mysqlDateTimeFormat = `${year}-${month}-${day}`;
    }
    const SearchData = {
      customer_id: customerId,
      phone: phoneNo,
      email: email,
      company_name: companyName,
      last_login: mysqlDateTimeFormat,
      status: status || '',
    };
   
    setCurrentPage(1)
    setCustomerSearchData(SearchData)
  };

  function handleClearFilter(e) {
    e.preventDefault();
    setCustomerId('');
    setPhoneNo('');
    setEmail('');
    setCompanyName('');
    setSelectedDate('');
    setStatus('');
    setCustomerSearchData(null);

    // Optionally reset the current page to 1 if you want to start from the first page
    setCurrentPage(1);
    getAllCustomers();
  }


  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const handleToggle = () => {
    setToggle(prevItem => ({ ...prevItem, isActive: !prevItem.isActive }));
  };

  const updateUserStatus = async (user_uuid, newStatus) => { 
          if (isAnyLoading) return; 
          setLoadingItemId(user_uuid); // Start loading for this specific item
          setIsAnyLoading(true);
          try {
              const response = await fetch(`${BASE_URL}user/update_user_status/${user_uuid}`, {
                  method: 'PUT',
                  headers: {
                      'Content-Type': 'application/json',
                      'accept': 'application/json',
                      'Authorization': token
                  },
                  body: JSON.stringify({ isActive: newStatus }),
              });
  
              if (!response.ok) {
                  throw new Error('Failed to update user status on the server.');
              }
              const updatedUserData = await response.json(); 
  
              // If API call is successful, update the local state to reflect the change
              setData(prevUsers =>
                  prevUsers.map(customer =>
                      customer.customer_uuid === user_uuid ? { ...customer, isActive: newStatus } : customer
                  )
              );
              toast.success("Customer status updated successfully.");
              
              console.log(`User ${user_uuid} status updated to ${newStatus} successfully.`);
  
          } catch (err) {
            console.log(err);
            if (err.response) {
              toast.warning(err.response.data.message);
            } else {
              toast.error("An unexpected error occurred: " + err.message);
            }
          } finally {
            setLoadingItemId(null); // Stop loading regardless of success or failure
            setIsAnyLoading(false);
          }
      };

  const handleEditCustomer = (customer_uuid, customerId, companyname) => {
    // Store the customerId in local storage
    localStorage.setItem('customerId-edit', customerId);
    localStorage.setItem('companyname-edit', companyname)
    // Navigate to the edit customer route with the customer UUID
    navigate(`/customerlist/edit-customer/${customer_uuid}`);
  };


  const handleAddcustomer = () => {
    navigate('/customerlist/addcustomer')
  }


  const handleViewCustomer = (customer_uuid) => {
    setIsLoadingCustomer(true);
    setSelectedCustomerId(customer_uuid);
    setTimeout(() => {
      setViewModalOpen(true); // Open the view modal after loading
      setIsLoadingCustomer(false); // End loading
    }, 100);
  };

  function formatDateTimeToUS(serviceStartDate) {
    const date = new Date(serviceStartDate);

    // Format the date to mm-dd-yyyy
    const formattedDate = date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit' 
    });

    // Format the time to hh:mm:ss
    const formattedTime = date.toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit', 
        second: '2-digit', 
        hour12: false // Set to true for 12-hour format
    });

    // Combine date and time
    return `${formattedDate} ${formattedTime}`;
  }

  

  return (
    <>
      <ToastContainer />
      <div className="top_section">

        <div className="pagesNamelink">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><Link to="/dashboard">{t("admindashboard.dashboard")}</Link></li>
              <li className="breadcrumb-item text-white">{t("customers.customers")}</li>
            </ol>
          </nav>
          <h4 className="text-white">{t("customers.customerslist")}</h4>
        </div>
        <button onClick={() => handleAddcustomer()} className="main_btn no-underline"><i className="fa-solid fa-plus"></i>{t("customers.addcustomer")}</button>
      </div>

      <div className="mainSection">
        <div className='row g-3 align-items-end justify-end mb-3'>
          <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-4 col-sm-12">
            <button className="cancel_btn ms-auto" onClick={handleClearFilter}>{t("customers.clearfilters")}</button>
          </div>
        </div>

        <div className="mainTable table-responsive">
          <form id="filterForm" onSubmit={handleSearch}>
            <table id="example" className="table table-striped table-dark">
              <thead>
                <tr>
                  <th>{t("customers.customerid")}</th>
                  <th>{t("customers.phone")}</th>
                  <th>{t("customers.email")}</th>
                  <th>{t("customers.companyname")}</th>
                  <th>{t("customers.lastlogindate")}</th>
                  <th>{t("customers.status")}</th>
                  <th>{t("customers.actions")}</th>
                </tr>
              </thead>
              <tbody disabled={loading}>
                {/* Search Inputs Row */}
                <tr>
                  <th>
                    <input type="text" className="form-control" placeholder="Customer ID" value={customerId} onChange={(e) => setCustomerId(e.target.value)} />
                  </th>
                  <th>
                    <input type="text" className="form-control" placeholder="Phone No"
                      value={phoneNo}
                      onChange={(e) => setPhoneNo(e.target.value)}
                    />
                  </th>
                  <th>
                    <input type="text" className="form-control" placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </th>
                  <th>
                    <input type="text" className="form-control" placeholder="Company Name"
                      value={companyName}
                      onChange={(e) => setCompanyName(e.target.value)}
                    />
                  </th>
                  <th>
                    <DatePicker
                        selected={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        showMonthDropdown
                        dateFormat="MM/dd/yyyy"
                        wrapperClassName='w-full'
                        className="form-control"
                        placeholderText="Last Login Date"
                    />
                  </th>
                  <th>
                    <select className="form-select"
                      value={status}
                      onChange={handleStatusChange}
                    >
                      <option value={true}>Active</option>
                      <option value={false}>In Active</option>
                    </select>
                  </th>
                  <th>
                    <button type="submit" className="secondary_btn">Apply</button>
                  </th>

                </tr>

                {/* Customer Data Rows */}
                {customerData && customerData.length > 0 ? (
                  customerData.map((customer, index) => (
                    <tr key={index}>
                      <td>{customer.customerId}</td>
                      <td>{customer.phone || 'N/A'}</td>
                      <td>{customer.email}</td>
                      <td>{customer.company_name || 'N/A'}</td>
                      <td>{customer.last_login ? formatDateTimeToUS(customer.last_login) : 'N/A'}</td>
                      <td>
                        <ToggleButton
                            item={{ isActive: customer.isActive }}
                            onToggle={() => updateUserStatus(customer.customer_uuid, !customer.isActive)}
                            //isLoading={loadingItemId === item.user_uuid}
                            isAnyLoading={isAnyLoading}
                        />
                        {loadingItemId === customer.customer_uuid && <Loader />}
                      </td>
                      <td>
                        {customer.isDeleted ? (
                          <div className="actionBtn flex justify-between gap-2 items-center">
                            <button className="restore" onClick={() => restoreCustomeralert(customer.customerId)}>
                              <MdRestore style={{ fontSize: '25px', color: '#1E90FF'}} />
                            </button>
                          </div>
                          ) : (
                            <div className="actionBtn flex justify-between gap-2 items-center">
                              <Link className="view" onClick={() => handleViewCustomer(customer.customer_uuid)}>
                                <img src={ViewIcon} alt="View" />
                              </Link>
                              <button onClick={() => handleEditCustomer(customer.customer_uuid, customer.customerId, customer.company_name)} className="Edit">
                                <img src={EditIcon} alt="Edit" />
                              </button>
                              <button className="Delete" onClick={() => deleteCustomeralert(customer.customerId)}>
                                <img src={DeleteIcon} alt="Delete" />
                              </button>
                            </div>
                          )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">No customer data found.</td>
                  </tr>
                )}

              </tbody>
            </table>
          </form>
        </div>
        {customerData.length > 0 &&
          <div>
            <Pagination
              itemsPerPage={itemsPerPage}
              totalItems={totalItems}
              paginate={paginate}
              currPage={currentPage}
            />
          </div>
        }
        <div>
          <ViewCustomer
            viewModalOpen={viewModalopen}
            setViewModalOpen={setViewModalOpen}
            customerUuid={selectedCustomerId}
            loading={isLoadingCustomer}
          />
        </div>
      </div>
    </>
  )
}

export default CustomerList;